import API from '@/api/Api';
import Constant from '@/constant';

export default {
    [Constant.FETCH_POLICY]: (store, payload) => {
        return new Promise((resolve, reject) => {

            API.fetchPolicy(payload.policyId)
                .then((response) => {
                    resolve(response.data)                    
                })
                .catch((err) => {
                    reject(err);
                })
        })
    },
    [Constant.FETCH_ANNOUNCEMENT]: (store, payload) => {
        return new Promise((resolve, reject) => {
            API.fetchPolicy(payload.announcementId)
                .then((response) => {                   
                    resolve(response.data.data)                  
                })
                .catch((err) => {
                    reject(err);
                })
        })
    },
    [Constant.FETCH_CATEGORIES]: (store, payload) => {
        return new Promise((resolve, reject) => {
            API.fetchCategories()
                .then((response) => {                   
                    resolve(response.data)                  
                })
                .catch((err) => {
                    reject(err);
                })
        }) 
    },
    [Constant.FORCE_CARD_CREATED]: (store, payload) => {
        return new Promise((resolve, reject) => {
            API.initializeCardInfo(store.state.card)
                .then((response) => {                   
                    resolve(response.data)                  
                })
                .catch((err) => {
                    reject(err.response.data.error);
                })
        }) 
    }
}


// WEBPACK FOOTER //
// ./src/store/actions.js